import {h, render, Component} from 'preact';
import {useState} from 'preact/hooks';
import ReactPaginate from 'react-paginate';
import { getQueryParams, setQueryParams } from './getQueryParams';
import {Fragment} from 'react';

import Result from './Result';
import Program from './Program';
import Sidebar from './Sidebar';
import FiltersMobile from './FiltersMobile';
import Search from './Search';

const finderPage = document.querySelector('.online-programs-finder');

/*
const parseDateToSortDate = (dateStr) => {
  const sortDateParsed = /^(\d{1,2})\/(\d{1,2})\/(\d{4})/.exec(dateStr);

  // To sort the null dates at the beginning
  if (!sortDateParsed) return '0000-00-00';

  return sortDateParsed[3].padStart(2, '0') +
    '-' + sortDateParsed[1].padStart(2, '0') +
    '-' + sortDateParsed[2];
};
*/

const processSemicolonElements = (arr) => {
  arr.forEach((element, index) => {
    if (element.includes(';')) {
      const parts = element.split(';');
      parts.forEach(part => {
        if (!arr.includes(part)) {
          arr.push(part);
        }
      });
      arr.splice(index, 1);
    }
  });
};

if (finderPage) {

  (async() => {
    const response = await fetch(jsonUrl);
    const json = await response.json();
    const rawPrograms = json.programs;

    const allPrograms = rawPrograms.map(program => {
      //const rawSortDate = program.datesList[0];
      //const sortDate = parseDateToSortDate(rawSortDate);

      processSemicolonElements(program.search);

      processSemicolonElements(program.area);

      // Normalize program types.
      const programDurations = Object.values(program.duration).sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' })).flat().join(', ');

      let type = '';
      let type_human = '';
      switch(programDurations) {
        case 'Certificate Program':
          type = 'cert';
          type_human = 'Certificate Program';
          break;
        case 'Four-Week Course':
          type = '4w';
          type_human = 'Four-Week Course';
          break;
        case 'Private Lessons':
          type = 'private';
          type_human = 'Private Lessons';
          break;
      }

      return Object.assign(program, {
        key: [program.name].join(''),
        searchString: [program.name, program.search, program.paragraph, program.instructorName]
          .join(' ')
          .toLowerCase()
          .replace(/[^a-z0-9]/g, ''),
        //sortDate,
        popularity: program.popularity === null ? 0 : program.popularity,
        type: type,
        type_human: type_human,
      });
    });

    const finderMode = window.finderMode || 'all';
    const isCertificateMode = finderMode === 'certificates';
    const programs = isCertificateMode
      ? allPrograms.filter(p => p.type === 'cert')
      : allPrograms;

    const queryParams = getQueryParams();
    if (isCertificateMode && queryParams.preFilterFilters) {
      delete queryParams.preFilterFilters.duration;
    }

    function OnlineProgramsFinder(props) {
      const perPage = 15;
      const [filters,
        setFiltersActual] = useState(queryParams.preFilterFilters || "");
      const [search,
        setSearchActual] = useState(queryParams.preFilterSearch || "");
      //const [sort, setSort] = useState({az: true, pop: true});
      const [page, setPage] = useState(0);

      const setFilters = (newFilters) => {
        setQueryParams(newFilters, search);
        setFiltersActual(newFilters);
        setPage(0);
      };

      const setSearch = (newSearch) => {
        setQueryParams(filters, newSearch);
        setSearchActual(newSearch);
        setPage(0);
      };

      // Reseet the filter interface.
      const resetFiltersAndSearch = () => {
        setFilters({});
        setSearch('');
        setPage(0);
      }

      // Check to see if there are any active filters.
      const filtersAreEmpty = () => {
        let empty = true;
        if(!filters){return empty;}
        if(search.length > 0) {
          empty = false;
        }

        for (let [key, value] of Object.entries(filters) ) {
          if(value && value.length > 0){
            empty = false;
          }
        }

        return empty;
      };

      const filteredPrograms = programs.filter(program => {
        let include = true;

        Object
          .keys(filters)
          .forEach(filterName => {
            const filter = filters[filterName];

            if(filterName === 'view'){

              // Filter out popular programs.
              if(filter.includes('Popular') || filter.includes('popular')){
                include = program.popularity > 0;
              }

              // Filter out new programs.
              if(filter.includes('New') || filter.includes('new')){
                include = program.newProgram;
              }
              return;
            }

            if (include === false)
              return;
            if (filter.length === 0)
              return;
            if (!program[filterName])
              return;

            include = program[filterName].some(val => filter.indexOf(val) >= 0);
          });

        if (include) {
          const searchString = search
            .toLowerCase()
            .replace(/[^a-z0-9]/g, '');

          if (searchString.length > 0) {
            if (program.searchString.indexOf(searchString) < 0)
              include = false;
            }
          }

        return include;
      }).sort((a, b) => {
        // Sort by A-Z, with a fallback for popularity if the values are the same.
        if(a.popularity == b.popularity){
          return a.name.localeCompare(b.name, 'en', { sensitivity: 'base' });
        } else {
          if(a.popularity == 0){return 1;} // Handle 0 values
          if(b.popularity == 0 ){return -1;}
          return a.popularity - b.popularity; // Asecending ordering.
        }
      });


      // Provide a callback for building filters from a UI button in the feed itself.
      const handleViewButtonClick = (option, target, view = false) => () => {
        let additionalFilters = [];

        const currentFilters = filters[target] || [];

        const active = currentFilters.indexOf(option) > -1;

        if (active) {
          // Views erase all current filters.
          if(view === true){

            // Set sort states for views.
            //if(option == 'Popular'){
            //  setSort({az: true, pop: false});
           // }

            // Allow view button toggling.
            const newFilters = [];
            setFilters(Object.assign({}, {}, {
              [target]: newFilters
            }));
          } else {
            const newFilters = currentFilters.filter(i => i !== option);
            setFilters(Object.assign({}, filters, {
              [target]: newFilters
            }));
          }
        } else {
           // Views erase all current filters.
          if(view === true) {

            // Set sort state for views.
            //if(option === 'Popular'){
            //  setSort({az: false, pop: true});
           // }

            const newFilters = [
              option
            ];
            setFilters(Object.assign({}, {}, {
              [target]: newFilters
            }));

          } else {
          const newFilters = [
            ...currentFilters,
            ...additionalFilters,
            option
          ];
          setFilters(Object.assign({}, filters, {
            [target]: newFilters
          }));
          }
        }

        if (view === false){
          document.getElementById("finder-top").scrollIntoView();
        }
      }

      const sliceStart = page * perPage;
      const sliceEnd = sliceStart + perPage;
      const slicedPrograms = filteredPrograms.slice(sliceStart, sliceEnd);

      const count = Math.ceil(filteredPrograms.length / perPage);

      const handleChange = (e) => {
        setPage(e.selected);
      };

      const handleModal = () => {

        const dialog = document.getElementById('io-program-finder-dialog');
        if (!dialog) { return; }

        if (!dialog.attributes.open) {
          dialog.showModal();
        } else {
          dialog.close();
        }
      };

      return (
        <>
        <div id="finder-top" className="container">

          <div className="filters">
            <Search
              programs={programs}
              filters={filters}
              setFilters={setFilters}
              search={search}
              setSearch={setSearch}
              handleViewButtonClick={handleViewButtonClick}
              mode={finderMode}
              //sort={sort}
              //setSort={setSort}
            />
            <FiltersMobile
              programs={programs}
              filters={filters}
              setFilters={setFilters}
              search={search}
              setSearch={setSearch}
              handleViewButtonClick={handleViewButtonClick}
              mode={finderMode}
              //sort={sort}
              //setSort={setSort}
            />
          </div>


          <div className="finder__bottom finder__bottom--split">

          <Sidebar
            programs={programs}
            filters={filters}
            setFilters={setFilters}
            handleViewButtonClick={handleViewButtonClick}
            mode={finderMode}
            //sort={sort}
            //setSort={setSort}
          />

            <div className="finder__bottom--right">

            <Result
            setFilters={setFilters}
            setSearch={setSearch}
            resetFiltersAndSearch={resetFiltersAndSearch}
            filteredPrograms={filtersAreEmpty() == true ? filteredPrograms : slicedPrograms}
            filters={filters}
            search={search}/>

            {filteredPrograms.length > 0
              ? ''
             : <div class="h5">{Drupal.t("No Matches")}</div>}

              {filtersAreEmpty() == true && !isCertificateMode // Print out sectionated programs when in a default view.
                ?
               <>
                  <div className="program-section-wrapper">
                    <h2 className="cert-program-header">{Drupal.t("Four-Week Courses")}</h2>
                    <ul className="finder__list--io-programs io-programs__4w">
                      {
                        filteredPrograms.filter(el => el.type == '4w').map((c, i) => {
                          if (i < 6) {
                            return (
                              <Program source={props.source} key={c.key} id={i} programs={c} />
                            );
                          }
                        })}
                    </ul>
                    <div class="program-cta">
                      <button
                        className="button button--outline"
                        aria-label={Drupal.t("See more four-week courses")}
                        onClick={handleViewButtonClick("Four-Week Course", "duration")}
                      >
                        {Drupal.t("See More")}
                      </button>
                    </div>
                  </div>

                  <div className="program-section-wrapper">
                    <h2 className="cert-program-header">{Drupal.t("Certificate Programs")}</h2>
                    <ul className="finder__list--io-programs io-programs__cert">
                      {filteredPrograms.filter(el => el.type == 'cert').map((c, i) => {
                        if (i < 6) {
                          return (
                            <Program source={props.source} key={c.key} id={i} programs={c} />
                          );
                        }
                      })}
                    </ul>
                    <div className="program-cta">
                      <button
                        className="button button--outline"
                        aria-label={Drupal.t("See more certificate programs")}
                        onClick={handleViewButtonClick("Certificate Program", "duration")}
                      >
                        {Drupal.t("See More")}
                      </button>
                    </div>
                  </div>

                  <div className="program-section-wrapper">
                    <h2 className="cert-program-header">{Drupal.t("Private Lessons")}</h2>
                    <ul className="finder__list--io-programs io-programs__private">
                      {filteredPrograms.filter(el => el.type == 'private').map((c, i) => {
                        if (i < 6) {
                          return (
                            <Program source={props.source} key={c.key} id={i} programs={c} />
                          );
                        }
                      })}
                    </ul>
                    <div className="program-cta">
                      <button
                        className="button button--outline"
                        aria-label={Drupal.t("See more private lessons")}
                        onClick={handleViewButtonClick("Private Lessons", "duration")}
                      >
                        {Drupal.t("See More")}
                      </button>
                    </div>
                  </div>
                </>
                :
               <>
               <ul className="finder__list--io-programs io-programs__default">
                 {slicedPrograms.map((c, i) => <Program source={props.source} key={c.key} id={i} programs={c} />)
                  }
                </ul>
               </>
              }

              {(filteredPrograms.length > perPage && (!filtersAreEmpty() || isCertificateMode))
              ? <ReactPaginate
              previousLabel={"prev"}
              previousLinkClassName={"pagination__prev"}
              nextLabel={"next"}
              nextLinkClassName={"pagination__next"}
              pageLinkClassName={"pagination__link"}
              breakClassName={"pagination__summary"}
              pageCount={count}
              pageRangeDisplayed={2}
              marginPagesDisplayed={1}
              onPageChange={handleChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
              forcePage={page}
              />
              : ''
            }

            </div>
          </div>
        </div>
        <dialog className="finder__preview-modal" id="io-program-finder-dialog">
          <button onClick={handleModal} className="finder__preview-modal-cloase">{Drupal.t("Close")}</button>
          <h2>{Drupal.t("This is only a preview")}</h2>
          <p>{Drupal.t("Complete the form to unlock all the details about our programs")}</p>
        </dialog>
        </>
      );
    }

    // Hides spinner.
    finderPage.innerHTML = '';
    const App = <OnlineProgramsFinder source={window.source} programs={programs} mode={finderMode}/>

    render(App, finderPage);
  })();

}
